<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-text-field
          label="Template Name"
          placeholder="Template Name"
          outlined
          v-model="messageTemplate.template_name"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field
          label="Template Slug"
          placeholder="template_slug"
          outlined
          v-model="messageTemplate.template_slug"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea
          outlined
          :name="refName"
          label="Template"
          v-model="messageTemplate.template"
          @click="selectTextArea"
          :ref="refName"
      ></v-textarea>
    </v-col>
    <v-col cols="6">
      <slot name="saveBtn">
        <v-btn block primary color="primary"  @click="saveOnClick">Update</v-btn>
      </slot>
    </v-col>
    <v-col cols="6">
      <slot name="deleteBtn">
        <v-btn block color="error" @click="deleteOnClick">Delete</v-btn>
      </slot>
    </v-col>
  </v-row>



</template>

<script>
export default {
  name: "MessageTemplateForm",
  data: () => ({
    refName: null
  }),
  props: {
    messageTemplate: Object
  },
  methods: {
    selectTextArea() {
      this.$emit('selectTextArea', {refName: this.refName, templateId: this.messageTemplate.id})
    },
    deleteOnClick() {
      this.$emit('deleteTemplate', this.messageTemplate.id)
    },
    saveOnClick() {
      this.$emit('saveTemplate', this.messageTemplate)
    }
  },
  mounted() {
    this.refName = `messageTemplate${this.messageTemplate.id}`;
  }
}
</script>

<style scoped>

</style>